/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { sizesByDensity } from './sizesByDensity';
import { colorsByTheme } from './colors';
var COLOR_MODES;

(function (COLOR_MODES) {
  COLOR_MODES["DARK"] = "dark";
  COLOR_MODES["LIGHT"] = "light";
})(COLOR_MODES || (COLOR_MODES = {}));

var DENSITY_MODES;

(function (DENSITY_MODES) {
  DENSITY_MODES["COMFORTABLE"] = "comfortable";
  DENSITY_MODES["COMPACT"] = "compact";
})(DENSITY_MODES || (DENSITY_MODES = {}));

var colorValues = Object.values(COLOR_MODES);
var densityValues = Object.values(DENSITY_MODES);
var env = process.env.NODE_ENV;
var shouldWarn = true;

var warn = function (warning) {
  if (shouldWarn) {
    if (env !== 'production' && env !== 'test') {
      shouldWarn = false; // eslint-disable-next-line no-console

      console.warn(warning);
    }
  }
};

var themeFn = function (fn) {
  return function (props) {
    var defaults = {
      colors: colorsByTheme.dark,
      sizes: sizesByDensity.comfortable
    };

    if (props.theme && props.theme.mode && props.theme.density) {
      var hasIncorrectModeValue = colorValues.some(function (v) {
        return v === props.theme.mode;
      }) === false;

      if (hasIncorrectModeValue) {
        warn("\"" + props.theme.mode + "\" is not a supported color mode. " + ("Available color modes: " + colorValues.map(function (v) {
          return "\"" + v + "\"";
        }).join(', ')));
        return fn(defaults);
      }

      var hasIncorrectDensityValue = densityValues.some(function (v) {
        return v === props.theme.density;
      }) === false;

      if (hasIncorrectDensityValue) {
        warn("\"" + props.theme.density + "\" is not a supported theme density. " + ("Available density modes: " + densityValues.map(function (v) {
          return "\"" + v + "\"";
        }).join(', ')));
        return fn(defaults);
      }

      return fn({
        colors: colorsByTheme[props.theme.mode],
        sizes: sizesByDensity[props.theme.density]
      });
    }

    return fn(defaults);
  };
};

export { themeFn };